(function () {
  'use strict';

  var overlay = document.querySelector('[data-focal-cart-overlay]');
  var drawer = document.querySelector('[data-focal-cart-drawer]');
  if (!drawer) return;

  var body = drawer.querySelector('[data-focal-cart-body]');
  var emptyState = drawer.querySelector('[data-focal-cart-empty]');
  var content = drawer.querySelector('[data-focal-cart-content]');
  var footer = drawer.querySelector('[data-focal-cart-footer]');
  var itemsList = drawer.querySelector('[data-focal-cart-items]');
  var titleEl = drawer.querySelector('[data-focal-cart-title]');
  var totalEl = drawer.querySelector('[data-focal-cart-total]');
  var shippingMsg = drawer.querySelector('[data-focal-shipping-msg]');
  var shippingFill = drawer.querySelector('[data-focal-shipping-fill]');
  var recsPanel = drawer.querySelector('[data-focal-cart-recs]');
  var recsList = drawer.querySelector('[data-focal-cart-recs-list]');
  var cartCountBubbles = document.querySelectorAll('[data-focal-cart-count]');
  var threshold = parseFloat(body.getAttribute('data-threshold')) || 100;
  var recsSource = recsPanel ? recsPanel.getAttribute('data-recs-source') : 'automatic';
  var recsCollection = recsPanel ? recsPanel.getAttribute('data-recs-collection') : '';

  var lastAddedProductId = null;

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format((cents || 0) / 100);
    } catch (e) {
      return '$' + ((cents || 0) / 100).toFixed(2);
    }
  }

  function open() {
    overlay.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      overlay.classList.add('is-visible');
      drawer.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
  }

  function close() {
    overlay.classList.remove('is-visible');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () { overlay.hidden = true; }, 400);
  }

  drawer.querySelectorAll('[data-focal-cart-close]').forEach(function (b) { b.addEventListener('click', close); });
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  function bumpCartCount() {
    cartCountBubbles.forEach(function (el) {
      el.classList.remove('is-bumped');
      void el.offsetWidth;
      el.classList.add('is-bumped');
    });
  }

  function renderShippingBar(cart) {
    var thresholdCents = threshold * 100;
    var remaining = thresholdCents - cart.total_price;
    var pct = Math.min(100, (cart.total_price / thresholdCents) * 100);
    shippingFill.style.width = pct + '%';
    if (remaining <= 0) {
      shippingMsg.innerHTML = 'You are eligible for <strong>free shipping!</strong>';
    } else {
      shippingMsg.innerHTML = 'Add <strong>' + formatMoney(remaining, cart.currency) + '</strong> more for free shipping!';
    }
  }

  function renderItems(cart) {
    itemsList.innerHTML = cart.items.map(function (item) {
      var variantText = item.variant_title ? item.variant_title.split(' / ').join(' / ') : '';
      var img = item.image ? item.image.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_180x$1$2') : '';
      return (
        '<li class="focal-cart-line-item" data-focal-line-key="' + item.key + '">' +
          '<div class="focal-cart-line-item__image-wrap">' +
            (img ? '<img class="focal-cart-line-item__image" src="' + img + '" alt="' + item.product_title + '" loading="lazy">' : '') +
          '</div>' +
          '<div class="focal-cart-line-item__info">' +
            '<div class="focal-cart-line-item__top">' +
              '<a class="focal-cart-line-item__title" href="' + item.url + '">' + item.product_title + '</a>' +
              '<span class="focal-cart-line-item__price">' + formatMoney(item.final_line_price, cart.currency) + '</span>' +
            '</div>' +
            (variantText ? '<p class="focal-cart-line-item__variant">' + variantText + '</p>' : '') +
            '<div class="focal-cart-line-item__bottom">' +
              '<div class="focal-cart-qty">' +
                '<button type="button" data-focal-qty-decrease>&minus;</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-focal-qty-increase>+</button>' +
              '</div>' +
              '<button type="button" class="focal-cart-line-item__remove" data-focal-line-remove>Remove</button>' +
            '</div>' +
          '</div>' +
        '</li>'
      );
    }).join('');
  }

  function setDrawerState(cart) {
    var isEmpty = cart.item_count === 0;
    // Toggle both the hidden attribute AND an explicit class, so display is
    // never fought by any other CSS rule that might set display on these
    // elements (belt-and-braces alongside the [hidden] !important CSS rule).
    emptyState.hidden = !isEmpty;
    emptyState.classList.toggle('is-visible', isEmpty);
    content.hidden = isEmpty;
    content.classList.toggle('is-visible', !isEmpty);
    footer.hidden = isEmpty;
    if (isEmpty && recsPanel) { recsPanel.hidden = true; }
  }

  function renderCart(cart) {
    titleEl.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
    totalEl.textContent = formatMoney(cart.total_price, cart.currency);
    cartCountBubbles.forEach(function (el) { el.textContent = cart.item_count; });

    setDrawerState(cart);

    if (cart.item_count === 0) return cart;

    renderShippingBar(cart);
    renderItems(cart);
    loadRecommendations(cart);
    return cart;
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart);
  }

  function renderRecommendations(products) {
    if (!recsPanel) return;
    if (!products.length) { recsPanel.hidden = true; return; }
    recsPanel.hidden = false;
    recsList.innerHTML = products.slice(0, 4).map(function (p) {
      var img = p.featured_image ? p.featured_image.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_400x$1$2') : (p.images && p.images[0]);
      var price = formatMoney(p.price);
      var compare = p.compare_at_price && p.compare_at_price > p.price ? '<span class="focal-price--compare">' + formatMoney(p.compare_at_price) + '</span>' : '';
      return (
        '<div class="focal-cart-rec-item">' +
          '<a href="' + p.url + '" class="focal-cart-rec-item__image-wrap">' +
            (img ? '<img class="focal-cart-rec-item__image" src="' + img + '" alt="' + p.title + '" loading="lazy">' : '') +
          '</a>' +
          '<p class="focal-cart-rec-item__title">' + p.title + '</p>' +
          '<p class="focal-cart-rec-item__price"><span class="focal-price--sale">' + price + '</span>' + compare + '</p>' +
          '<a href="' + p.url + '" class="focal-cart-rec-item__quickview">Quick view</a>' +
        '</div>'
      );
    }).join('');
  }

  /* Loads "You may also like" either from a merchant-chosen collection
     (set in Theme Editor) or automatically based on a product in the cart.
     Runs every time the cart renders — not just right after an add — so
     recommendations still show when the drawer is opened via the cart icon. */
  function loadRecommendations(cart) {
    if (!recsPanel) return;

    if (recsSource === 'collection' && recsCollection) {
      fetch('/collections/' + recsCollection + '/products.json?limit=4')
        .then(function (r) { return r.json(); })
        .then(function (data) { renderRecommendations((data && data.products) || []); })
        .catch(function () { recsPanel.hidden = true; });
      return;
    }

    var productId = lastAddedProductId || (cart.items.length ? cart.items[cart.items.length - 1].product_id : null);
    if (!productId) { recsPanel.hidden = true; return; }

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=4&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) { renderRecommendations((data && data.products) || []); })
      .catch(function () { recsPanel.hidden = true; });
  }

  function changeLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  itemsList.addEventListener('click', function (e) {
    var li = e.target.closest('[data-focal-line-key]');
    if (!li) return;
    var key = li.getAttribute('data-focal-line-key');
    var qtySpan = li.querySelector('.focal-cart-qty span');
    var qty = parseInt(qtySpan.textContent, 10);

    if (e.target.closest('[data-focal-qty-increase]')) changeLine(key, qty + 1);
    if (e.target.closest('[data-focal-qty-decrease]')) changeLine(key, Math.max(0, qty - 1));
    if (e.target.closest('[data-focal-line-remove]')) changeLine(key, 0);
  });

  document.addEventListener('focal:cart-open', function () { fetchCart().then(open); });

  /* -----------------------------------------------------------------------
     KEY FIX: instead of intercepting product-form submits (which raced /
     duplicated with Dawn's own add-to-cart JS), we passively OBSERVE the
     network. Whichever script (Dawn's or a plain form) performs the actual
     POST to /cart/add(.js), we detect it here, refresh our own cart data,
     and open our drawer — with zero interference in the original request.
     ----------------------------------------------------------------------- */
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isAddToCart = url.indexOf('/cart/add') !== -1;

    return nativeFetch.apply(this, arguments).then(function (response) {
      if (isAddToCart && response.ok) {
        response.clone().json().then(function (item) {
          if (item && !item.status) {
            lastAddedProductId = item.product_id || item.id || lastAddedProductId;
            fetchCart().then(function () {
              bumpCartCount();
              open();
            });
          }
        }).catch(function () { /* not JSON / different endpoint shape, ignore */ });
      }
      return response;
    });
  };

  /* Fallback for themes/forms that submit /cart/add via a plain (non-JS)
     form post rather than fetch — only acts if nothing else has already
     prevented the default submission. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (e.defaultPrevented) return; // another script (e.g. Dawn) already handles this via JS/fetch

    e.preventDefault();
    var formData = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        lastAddedProductId = item.product_id || item.id || lastAddedProductId;
        return fetchCart();
      })
      .then(function () { bumpCartCount(); open(); })
      .catch(function (err) { console.error('Focal cart: add to cart failed', err); });
  });
})();